import { Component, HostListener, inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';
@Component({
  selector: 'yes-no-feedback-dialog',
  templateUrl: `yes-no-feedback-dialog.html`,
  styleUrls: ['yes-no-feedback-dialog.css'],
  standalone: true,
  imports: [
    SiaTranslatePipe,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatFormField,
    FormsModule,
    MatButton,
    MatLabel,
    MatInput,
  ],
})
export class YesNoFeedbackDialogComponent implements OnDestroy {
  #dialogRef = inject<MatDialogRef<YesNoFeedbackDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  constructor() {
    this.#dialogRef.updateSize('min(95% , 600px)');
  }

  feedback?: string = '';

  onNoClick() {
    this.#dialogRef.close({ result: false, feedback: this.feedback });
  }
  onYesClick() {
    this.#dialogRef.close({ result: true, feedback: this.feedback });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key !== 'Enter') {
      return;
    }

    const target = event.target;
    const isTextarea = target instanceof HTMLTextAreaElement;

    // Dentro la textarea l'Enter "nudo" produce a-capo: confermiamo solo con
    // Ctrl/Cmd+Enter per non rompere la digitazione del commento.
    if (isTextarea && !event.ctrlKey && !event.metaKey) {
      return;
    }

    // Negli altri input (non presenti qui, ma per sicurezza) ed elementi
    // contenteditable manteniamo il comportamento nativo.
    if (
      target instanceof HTMLInputElement ||
      target instanceof HTMLSelectElement ||
      (target instanceof HTMLElement && target.isContentEditable && !isTextarea)
    ) {
      return;
    }

    event.preventDefault();
    this.onYesClick();
  }

  ngOnDestroy(): void {
    this.feedback = undefined;
  }
}
